import React from "react";

export const Five = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="52"
        height="52"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clip-path="url(#clip0_272_5978)">
          <path
            d="M16.1996 0.900024C12.1996 0.900024 8.44961 2.45002 5.64961 5.25002C1.04961 9.90003 -0.000390475 17.05 3.04961 22.8L0.949609 29.65C0.849609 30.05 0.949609 30.5 1.24961 30.8C1.44961 31 1.74961 31.1 2.04961 31.1C2.14961 31.1 2.29961 31.1 2.39961 31.05L8.99961 28.85C13.5496 31.4 18.9496 31.35 23.5496 28.75C28.2996 26.05 31.1496 21.2 31.1496 15.8C31.1496 7.60003 24.4496 0.900024 16.1996 0.900024ZM22.4496 26.8C18.4496 29.1 13.6496 29 9.69961 26.65C9.49961 26.55 9.29961 26.5 9.09961 26.5C8.99961 26.5 8.84961 26.5 8.74961 26.55L3.69961 28.2L5.34961 23C5.44961 22.7 5.39961 22.4 5.24961 22.1C2.39961 17.15 3.24961 10.9 7.29961 6.85002C9.69961 4.45002 12.8496 3.15002 16.2496 3.15002C23.2496 3.15002 28.8996 8.85003 28.8996 15.8C28.8996 20.4 26.4496 24.5 22.4496 26.8Z"
            fill="url(#paint0_linear_272_5978)"
          />
          <path
            d="M20.3492 10.35H12.0992C11.4992 10.35 10.9492 10.85 10.9492 11.5C10.9492 12.15 11.4492 12.65 12.0992 12.65H20.3492C20.9492 12.65 21.4992 12.15 21.4992 11.5C21.4992 10.85 20.9492 10.35 20.3492 10.35Z"
            fill="url(#paint1_linear_272_5978)"
          />
          <path
            d="M20.3492 14.8H12.0992C11.4992 14.8 10.9492 15.3 10.9492 15.95C10.9492 16.6 11.4492 17.05 12.0992 17.05H20.3492C20.9492 17.05 21.4992 16.55 21.4992 15.95C21.4992 15.35 20.9492 14.8 20.3492 14.8Z"
            fill="url(#paint2_linear_272_5978)"
          />
          <path
            d="M20.35 19H12.1C11.5 19 11 19.5 11 20.1C11 20.7 11.5 21.25 12.15 21.25H20.4C21 21.25 21.55 20.75 21.55 20.1C21.55 19.45 20.95 19 20.35 19Z"
            fill="url(#paint3_linear_272_5978)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_272_5978"
            x1="16.0309"
            y1="0.900024"
            x2="16.0309"
            y2="37.4895"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_272_5978"
            x1="16.2242"
            y1="10.35"
            x2="16.2242"
            y2="13.1366"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_272_5978"
            x1="16.2242"
            y1="14.8"
            x2="16.2242"
            y2="17.5261"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_272_5978"
            x1="16.275"
            y1="19"
            x2="16.275"
            y2="21.726"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <clipPath id="clip0_272_5978">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
